import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { lnsService } from "../services/lnsService";

// Query keys for consistent cache management
export const lnsKeys = {
  all: ["lns"],
  lists: () => [...lnsKeys.all, "list"],
  list: (filters) => [...lnsKeys.lists(), { filters }],
  details: () => [...lnsKeys.all, "detail"],
  detail: (id) => [...lnsKeys.details(), id],
};

// Custom hooks for LNS
export const useLnss = (options = {}) => {
  return useQuery({
    queryKey: lnsKeys.lists(),
    queryFn: lnsService.getLnss,
    ...options,
  });
};

export const useLns = (id, options = {}) => {
  return useQuery({
    queryKey: lnsKeys.detail(id),
    queryFn: () => lnsService.getLns(id),
    enabled: !!id,
    ...options,
  });
};

// Mutation hooks for LNS
export const useCreateLns = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: lnsService.createLns,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: lnsKeys.lists() });
    },
  });
};

export const useUpdateLns = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => lnsService.updateLns(id, data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: lnsKeys.lists() });
      queryClient.invalidateQueries({ queryKey: lnsKeys.detail(variables.id) });
    },
  });
};

export const useDeleteLns = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: lnsService.deleteLns,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: lnsKeys.lists() });
    },
  });
};
